var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmailSentSolid = function SvgEmailSentSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.938 6.5c.71 0 1.312.602 1.312 1.313 0 .437-.219.82-.547 1.066l-.383.273a4.852 4.852 0 0 0-3.992 3.008l-1.558 1.176a.862.862 0 0 1-1.067 0L3.77 8.879a1.309 1.309 0 0 1-.52-1.066c0-.711.574-1.313 1.313-1.313h11.375Zm-4.649 7.547L12 13.5v.438c0 1.175.41 2.242 1.094 3.062H5c-.984 0-1.75-.766-1.75-1.75V9.562l5.934 4.485a1.764 1.764 0 0 0 2.105 0Zm9.461-.11a3.938 3.938 0 0 1-3.938 3.938 3.921 3.921 0 0 1-3.937-3.938c0-2.16 1.75-3.937 3.938-3.937 2.16 0 3.937 1.777 3.937 3.938Zm-2.734-1.175-1.641 1.668-.793-.793a.463.463 0 0 0-.629 0 .463.463 0 0 0 0 .629l1.094 1.093a.463.463 0 0 0 .629 0l1.969-1.968a.463.463 0 0 0 0-.63.463.463 0 0 0-.63 0Z"
  })));
};

export default SvgEmailSentSolid;